<template>
    <ol class="breadcrumb">
        <li
            v-for="(breadcrumb, idx) in breadcrumbs"
            :key="idx"
            class="breadcrumb-item"
            :class="{ active: !breadcrumb.link }"
        >
            <template v-if="breadcrumb.link">
                <router-link :to="breadcrumb.link" :title="breadcrumb.name">{{
                    breadcrumb.name
                }}</router-link>
            </template>
            <template v-else :title="breadcrumb.name">
                {{ breadcrumb.name }}</template
            >
        </li>
    </ol>
</template>

<script>
export default {
    props: {
        // 頁面名稱
        pageTitle: {
            type: String,
        },
    },
    data() {
        return {
            breadcrumbs: [],
        };
    },
    mounted() {
        this.updateBreadcrumbs();
    },
    methods: {
        goView(breadcrumb) {
            if (breadcrumb.link) this.$router.push(breadcrumb.link);
        },
        updateBreadcrumbs() {
            const breadcrumbs = this.$route.meta.breadcrumb;
            Object.keys(this.$route.params).forEach((param) => {
                const breadcrumbMatch = breadcrumbs.filter((item) => {
                    if (!item.link) return false;
                    return item.link.indexOf(`:${param}`) > -1;
                });
                breadcrumbMatch.forEach((_, index) => {
                    breadcrumbMatch[index].name = this.pageTitle
                        || breadcrumbMatch[index].name
                        || this.$route.params[param];
                    breadcrumbMatch[index].link = breadcrumbMatch[
                        index
                    ].link.replace(`:${param}`, this.$route.params[param]);
                });
            });

            this.breadcrumbs = breadcrumbs;
        },
    },
    watch: {
        '$route.meta.breadcrumb': {
            handler() {
                this.updateBreadcrumbs();
            },
            deep: true,
        },
        pageTitle() {
            this.updateBreadcrumbs();
        },
    },
};
</script>
